import { render } from "./HormoneReplacementContentPtBR.vue?vue&type=template&id=4fc46a69&scoped=true"
import script from "./HormoneReplacementContentPtBR.vue?vue&type=script&lang=js"
export * from "./HormoneReplacementContentPtBR.vue?vue&type=script&lang=js"

import "./HormoneReplacementContentPtBR.vue?vue&type=style&index=0&id=4fc46a69&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc46a69"]])

export default __exports__